// extracted by mini-css-extract-plugin
export var callCard = "_or-0";
export var callMessageButton = "_or-1";
export var helpIcon = "_or-3";
export var helpIconContainer = "_or-4";
export var verticalDivider = "_or-2";